import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/tableField/crmedical/custom/tableField/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/tableField/crmedical/custom/tableField/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/tableField/crmedical/custom/tableField/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/tableField/crmedical/custom/tableField/submit', params,options)

export const update = (params, options) =>
request.post('/api/tableField/crmedical/custom/tableField/submit', params,options)
